module.exports = __webpack_public_path__ + "static/media/004.17a9b187.jpg";